import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./AdminLayout.scss";
import Header from "../../../containers/header/Header";
import Sidebar from "../../../containers/sidebar/Sidebar";
import Infobar from "../../../containers/infobar/infobar";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { otherDataAC } from "../../../store/action-creators";
import { DisclaimerBar, ProgressBox } from "../../../components";
import Dialog from '@mui/material/Dialog';
import { AddEmailDialog } from "../../../dialogs";

function AdminLayout() {
  const otherDataStore = useSelector((store: any) => store?.otherData);
  const balanceDataStore = useSelector((store: any) => store?.balance);
  const [infoBarData, setInfoBarData] = useState(null);
  const [isPlanDisclaimer, setIsPlanDisclaimer] = useState(false);
  const dispatch = useDispatch();
  const _otherData = bindActionCreators(otherDataAC, dispatch);
  const _location = useLocation();
  const [fileUploadProgress, setUploadProgress] = useState(0);
  const [fileUploadData, setUploadData] = useState<string>("");

  useEffect(() => {
    let componentMounted = true;
    infoBarData &&
      componentMounted &&
      otherDataStore?.isMobile &&
      _otherData.setOtherData({ sidebarClosed: true });
    return () => {
      componentMounted = false;
    };
  }, [infoBarData]);

  useEffect(() => {
    let componentMounted = true;
    !otherDataStore?.sidebarClosed &&
      otherDataStore?.isMobile &&
      infoBarData &&
      componentMounted &&
      setInfoBarData(null);
    return () => {
      componentMounted = false;
    };
  }, [otherDataStore?.sidebarClosed]);

  useEffect(() => {
    let componentMounted = true;
    if (_location.pathname !== "/dashboard" && componentMounted) {
      setInfoBarData(null);
    }
    if ((window.location.pathname === '/dashboard/topup') && componentMounted) {
      setIsPlanDisclaimer(false);
    }
    _otherData.setOtherData({ isVerifyEmailDialog: false });
    return () => {
      componentMounted = false;
    };
  }, [_location]);

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {

      if(balanceDataStore?.allTransactions?.length > 0 || balanceDataStore?.dataLimit > 1073741824){
        setIsPlanDisclaimer(false) 
      }else{
        window.location.pathname !== '/dashboard/topup' ?setIsPlanDisclaimer(true) : setIsPlanDisclaimer(false)
      }
    }
    return () => {
      componentMounted = false;
    };
  }, [balanceDataStore?.allTransactions])
  

  

  return (
    <div className="AdminLayoutContainer">
      <div className="headerContainer">
        <Header />
      </div>
      <div className="bodyContainer">
        <Sidebar
          setUploadProgress={setUploadProgress}
          setUploadData={setUploadData}
        />
        <div className="mainBody">
          <div className="mainBody__outletContainer">

            {
              isPlanDisclaimer &&   <div className="disclaimerBox">
              <DisclaimerBar 
                title={""} 
                content={"Your free trial is about to expire! Upgrade now to avoid losing your data. Don't wait—secure your content before it's too late."} isTopUpPlan={true} 
              />
            </div>
            }

        

          
            <Outlet context={[infoBarData, setInfoBarData]} />
            {fileUploadProgress > 0 && (
              <div className="progressContainer">
                <ProgressBox
                  fileUploadProgress={fileUploadProgress}
                  fileUploadData={fileUploadData}
                />
              </div>
            )}
          </div>
          <Infobar infoBarData={infoBarData} setInfoBarData={setInfoBarData} />
        </div>
      </div>
      <Dialog
        open={otherDataStore?.isVerifyEmailDialog}
        onClose={() => {
          // _otherData.setOtherData({ isVerifyEmailDialog: false });
        }}
      >
        <AddEmailDialog />
      </Dialog>
    </div>
  );
}

export default AdminLayout;
